export const COMMON_MESSAGES = {
  // Form validation messages
  SELECT_CRITERIA: "Lütfen en az bir arama kriteri giriniz.",
  SELECT_START_END_DATES: "Lütfen başlangıç ve bitiş tarihlerini seçiniz.",
  MIN_CHARACTER_LENGTH_2: "En az 2 karakter girilmelidir.",
  REQUIRED_FIELD: "Bu alan zorunludur.",

  // Data messages
  NO_DATA_FOUND: "Seçilen kriterlere uygun veri bulunamadı.",
  DATA_FETCH_ERROR: "Veriler alınırken bir hata oluştu.",

  // Date validation messages
  START_DATE_REQUIRED: "Lütfen başlangıç tarihini seçiniz.",
  END_DATE_REQUIRED: "Lütfen bitiş tarihini seçiniz.",
  START_DATE_GREATER_THAN_END: "Başlangıç tarihi bitiş tarihinden büyük olamaz!",
  END_DATE_LESS_THAN_START: "Bitiş tarihi başlangıç tarihinden küçük olamaz!",
  INVALID_DATE: "Geçersiz tarih.",
  INVALID_DATE_GENERIC: "Geçersiz tarih. Lütfen tekrar deneyin."
} as const; 